import React, { useState, useEffect, useContext } from "react";
import {Form} from "react-bootstrap";
import NotyfContext from "../contexts/NotyfContext";
import { Eye, UserCheck, File, FileText, Key } from "react-feather";
import { Table, Button, Modal} from "react-bootstrap";

import EditableExpires from "./EditableExpires";
import EditableExpiresControls from "./EditableExpiresControls";
import CopyToClipboardToggle from "./CopyToClipboardToggle";
import ParticipationStatusIcon from "./ParticipationStatusIcon";

import authenticatedFetch from "../utils/fetch"
import rawPrivilegesTypes from "../utils/privilegesTypes";
import { UserSettingsContext } from "../contexts/UserSettingsContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHospitalAlt,
  faClinicMedical,
} from "@fortawesome/free-solid-svg-icons";

import {
  faBuilding
} from "@fortawesome/free-regular-svg-icons";
import ParticipationDocumentsModal from "./ParticipationDocumentsModal";
import LoginCredentialsModal from "./LoginCredentialsModal";


const FacilityContactInfoModal = ({ show, onClose, facilityName, address1, address2, city, state, zip, county, phone, email, fax, hours, notes}) => {

  var copyFormatted = facilityName;
  copyFormatted += (address1 ? ("\n" + address1) : "")
  copyFormatted += (address2 ? ("\n" + address2) : "")
  copyFormatted += "\n" + (city ? city : "") + (state ? (", " + state) : "") + (zip ? (" " + zip) : "");
  copyFormatted += (phone ? ("\n" + phone) : "");
  copyFormatted += (fax ? ("\n" + fax) : "");
  copyFormatted += (email ? ("\n" + email) : "");
  copyFormatted += (hours ? ("\n" + hours) : "");
  copyFormatted += (notes ? ("\n" + notes) : "");

  const onCopyValue = () => {
    // No-op for now
  }

  return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Contact Info for: <b>{facilityName}</b></span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table className="table-borderless"> 
            <tbody>
              <tr>
                <td>
                  <b>Address:</b>
                </td>
                <td>
                {address1}
                <br />
                {address2
                ?
                <>{address2}
                <br />
                </>
                : <></>
                }
                {city}{city ? ", " : ""}{state} {zip}
                </td>
              </tr>
              <tr>
                <td><b>County:</b></td>
                <td>{county}</td>
              </tr>
              <tr>
                <td><b>Phone:</b></td>
                <td>{phone}</td>
              </tr>
              <tr>
                <td><b>Fax:</b></td>
                <td>{fax}</td>
              </tr>
              <tr>
                <td><b>Email:</b></td>
                <td>{email}</td>
              </tr>
              <tr>
                <td><b>Hours:</b></td>
                <td>{hours}</td>
              </tr>
              <tr>
                <td><b>Notes:</b></td>
                <td>{notes}</td>
              </tr>
            </tbody>
          </Table>
          <span className="float-end"><CopyToClipboardToggle text={copyFormatted} onCopyValue={onCopyValue}/></span>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
          <Button onClick={onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
  );
}



const FacilityParticipation = ({ onSave, facilityId, providerId, providerName, facilityName, phone, fax, email, hours, notes, facilityType, address1, address2, city, state, zip, county, expires, effectiveDate, privilegesType, portal, active, primary, progress, pending, pendingTimestamp, notApplicable, canEdit, showInactive=false}) => {
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const [showPortal, setShowPortal] = useState(false);
    const handleShowPortal = () => setShowPortal(true);
    const handleClosePortal = () => setShowPortal(false);
  
    if (privilegesType === null)
    {
        privilegesType = '';   
    }

    const [editingExpires, setEditingExpires] = useState(false);
    const [localExpires, setLocalExpires] = useState(expires);
    const [localEffectiveDate, setLocalEffectiveDate] = useState(effectiveDate);
    const [localPrivilegesType, setLocalPrivilegesType] = useState(privilegesType);
    const [localActive, setLocalActive] = useState(active);
    const [localNotApplicable, setLocalNotApplicable] = useState(notApplicable);
    const [localPrimary, setLocalPrimary] = useState(primary);
    const [showDocuments, setShowDocuments] = useState(false);
    const handleShowDocuments = () => setShowDocuments(true);
    const handleCloseDocuments = () => setShowDocuments(false);

    // Callback prop
    const [documentCount, setDocumentCount] = useState(0);
    
    const notyf = useContext(NotyfContext);
    const { pastHospitalPrivilegesRefresh, setPastHospitalPrivilegesRefresh } = useContext(UserSettingsContext);

    useEffect(() => {
      setLocalActive(active);
      setLocalNotApplicable(notApplicable);
      setLocalPrimary(primary);
      setLocalExpires(expires);
      setLocalEffectiveDate(effectiveDate);
      setLocalPrivilegesType(privilegesType); // TODO this is from early on - not sure we need this in useEffect
      setEditingExpires(false);
    }, [facilityId, providerId, active, expires, notApplicable]);
  
    const handleEditExpiresClicked = (e) =>
    {
      e.preventDefault();
      setEditingExpires(true);
    }
  
    const saveExpires = (e) =>
    {
      e.preventDefault();
      setEditingExpires(false);
  
      authenticatedFetch({
        path: "provider/participationstatus/facility/" + providerId + "/" + facilityId,
        method: "POST",
        requestData: {active: localActive, notApplicable: localNotApplicable, primary: localPrimary, expiration: localExpires, effectiveDate: localEffectiveDate, privilegesType: localPrivilegesType},
        successHandler: function() {
          onSave(); // easiest way to update expires (so undo works the next time) is just to have parent re-render us - TODO this is from early on 
          setPastHospitalPrivilegesRefresh(pastHospitalPrivilegesRefresh + 1);
          notyf.open({type: "success", message: "Saved!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
        },
        errorHandler: function() {
          setLocalActive(active);
          setLocalNotApplicable(notApplicable);
          setLocalPrimary(primary);
          setLocalExpires(expires);
          setLocalEffectiveDate(effectiveDate);
          setLocalPrivilegesType(privilegesType);
          alert("Something went wrong; please try again");
        }
      });
    }
  
    const cancelEditExpires = (e) => {
      e.preventDefault();
      setEditingExpires(false);
      setLocalActive(active);
      setLocalNotApplicable(notApplicable);
      setLocalPrimary(primary);
      setLocalExpires(expires);
      setLocalEffectiveDate(effectiveDate);
      setLocalPrivilegesType(privilegesType);
    }
  
    const handleActiveChanged = (e) => {
      e.preventDefault();

      if (e.target.value === "INACTIVE")
      {
        // Make it clear that we're wiping expires too (since server actually deletes this row)
        setLocalPrimary(false);
        setLocalExpires(null);
        setLocalEffectiveDate(null);
        setLocalPrivilegesType("");
        
        setLocalActive(false);
        setLocalNotApplicable(false);
      }
      else if (e.target.value === "ACTIVE")
      {
        setLocalActive(true);
        setLocalNotApplicable(false);
      }
      else if (e.target.value === "NOT_APPLICABLE")
      {
        // Make it clear that these are going to get nulled out
        setLocalPrimary(false);
        setLocalExpires(null);
        setLocalEffectiveDate(null);
        setLocalPrivilegesType("");

        setLocalActive(false);
        setLocalNotApplicable(true);
      }
    }
  
    const handlePrimaryChanged = (e) => {
      setLocalPrimary(e.target.checked);
    }

    const handleExpiresChanged = (date, e) => {
      e.preventDefault();
    
      // If they clear it out, date picker sends it back as "", not null
      if (date === "")
      {
        date = null;
      }
  
      setLocalExpires(date);
    }
  
    const handleEffectiveDateChanged = (date, e) => {
      e.preventDefault();
    
      // If they clear it out, date picker sends it back as "", not null
      if (date === "")
      {
        date = null;
      }
  
      setLocalEffectiveDate(date);
    }

    const handlePrivilegesTypeChanged = (e) => {
        e.preventDefault();

        setLocalPrivilegesType(e.target.value);
    }
  
      var activeSelectValue = "INACTIVE";
      if (localActive)
      {
        activeSelectValue = "ACTIVE";
      }
      else if (localNotApplicable)
      {
        activeSelectValue = "NOT_APPLICABLE"; 
      }

    let privilegesTypeList = rawPrivilegesTypes.map((privilegesType, i) => {
        return (
          <option key={i} value={privilegesType.value}>{privilegesType.label}</option>
        )
      }, this);
  
    var selectedPrivilegesTypeLabel = '';
    if (localPrivilegesType !== '')
    {
        for (let i = 0; i < rawPrivilegesTypes.length; i++)
        {
            if (localPrivilegesType === rawPrivilegesTypes[i].value)
            {
                selectedPrivilegesTypeLabel = rawPrivilegesTypes[i].label;
                break;
            }
        }
    }

    let showLocation = (active && !(privilegesType === 'VOLUNTARILY_RESIGNED' || privilegesType === 'EXPIRED' || notApplicable)) || progress || pending || showInactive;
 
    // Don't render hidden rows (display:none rows still count toward zebra striping)
    if (!showLocation) {
      return null;
    }

    return (
      <tr>
          <td>
            {facilityType === 'CLINIC' ?
            <FontAwesomeIcon icon={faBuilding} size="lg" style={{color: '#2B7A78'}}/>
            :(facilityType === 'ASC' ?
              <FontAwesomeIcon icon={faClinicMedical} size="lg" style={{color: '#2B7A78'}}/>
              :
              <FontAwesomeIcon icon={faHospitalAlt} size="lg" style={{color: '#2B7A78'}}/>
              )
            }
          </td>
          <td style={{maxWidth: '160px', paddingRight: '0'}}>
            {facilityName}
          </td>
          <td><Eye style={{cursor: 'pointer', height: '16px', width: '16px'}}  onClick={(e) => handleShow()}/></td>
          <td><Key style={{cursor: 'pointer', height: '16px', width: '16px'}}  onClick={(e) => handleShowPortal()}/></td>
          <td>
          {editingExpires && canEdit
          ? 
          <Form.Select size="sm" onChange={(e) => {handleActiveChanged(e)}} value={activeSelectValue} style={{minWidth: "80px"}} >
            <option value="INACTIVE" key="INACTIVE">Inactive</option>
            <option value="ACTIVE" key="ACTIVE">Active</option>
            <option value="NOT_APPLICABLE" key="NOT_APPLICABLE">(n/a)</option>
          </Form.Select>
          :  
          <ParticipationStatusIcon size={18} notApplicable={localNotApplicable} inProgress={progress} isPending={pending} pendingTimestamp={pendingTimestamp} isActive={localActive} isStopped={localActive && (privilegesType === 'VOLUNTARILY_RESIGNED' || privilegesType === 'EXPIRED')} />
          }
          </td>
          <td>
          {editingExpires && canEdit && localActive
          ? 
          <Form.Check checked={localPrimary} onChange={(e) => {handlePrimaryChanged(e)}} />  
          :  
          (localPrimary ? <UserCheck className="text-success" size={16} /> : <></>)
          }
          </td>
          <td>
          {localActive && !localNotApplicable ? 
            <>
            {documentCount > 0 ?
            <FileText style={{ color: "#3AAFA9", height: '16px', width: '16px', cursor: "pointer" }} onClick={(e) => {handleShowDocuments()}} />
            :
            <File style={{cursor: 'pointer', height: '16px', width: '16px'}} onClick={(e) => handleShowDocuments()}/>
            }
            <ParticipationDocumentsModal entityType='facility' providerId={providerId} providerName={providerName} entityId={facilityId} entityName={facilityName} show={showDocuments} onClose={handleCloseDocuments} onDocumentCountLoaded={setDocumentCount}/>
            </>
          : <></>}
          </td>
          <td>
            <EditableExpires blankText="—" warnWithColors={false} localExpires={localEffectiveDate} localActive={localActive} editingExpires={editingExpires} handleExpiresChanged={handleEffectiveDateChanged} />
          </td>
          <td>
            <EditableExpires blankText="—" localExpires={localExpires} localActive={localActive} editingExpires={editingExpires} handleExpiresChanged={handleExpiresChanged} />
          </td>
          <td>
            {editingExpires && canEdit && localActive ?
            <Form.Select size="sm" value={localPrivilegesType} onChange={(e) => {handlePrivilegesTypeChanged(e)}} style={{width: "auto"}} >
                {privilegesTypeList}
            </Form.Select>
            :
            <>{selectedPrivilegesTypeLabel}</>
            }
          </td>
          <td style={{minWidth: "60px"}}>
            {canEdit ?
              <EditableExpiresControls editingExpires={editingExpires} cancelEditExpires={cancelEditExpires} saveExpires={saveExpires} handleEditExpiresClicked={handleEditExpiresClicked} />
            : <>&nbsp;</>
            }
          </td>
          <FacilityContactInfoModal show={show} onClose={handleClose} facilityName={facilityName} address1={address1} address2={address2} city={city} state={state} zip={zip} county={county} phone={phone} fax={fax} email={email} hours={hours} notes={notes} />
          <LoginCredentialsModal isHub={true} hubType={"facility"} canEdit={canEdit} show={showPortal} onClose={handleClosePortal} entityType="provider" entityId={providerId} entityName={providerName} carrierName={facilityName} carrierId={facilityId} />
      </tr>
    );
  }

  export default FacilityParticipation;